export default {
  InitialInvoiceAmount: 0,
  InitialInvoiceCurrencyCode: null,
  InvoiceCurrencyCode: null,
  CurrentInvoicedAmount: 0,
  InvoiceId: 0,
  DueTime: null
}



// WEBPACK FOOTER //
// ./src/components/_modules/I2P/models/budget-scan-snapshot-model.js